import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["checked", "children", "classes", "disabled", "id", "indeterminate", "invalid", "name", "onChange", "readOnly", "required", "tabIndex", "textProps", "theme", "value"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { forwardRef, useCallback, useEffect, useState } from 'react';
import classNames from 'classnames/bind';
import { defaultPropObject } from "../constants";
import { CheckboxBase } from "../internal/CheckboxBase";
import { TextBase } from "../internal/TextBase";
import styles from './Checkbox.css';
var cx = classNames.bind(styles);
export var Checkbox = /*#__PURE__*/forwardRef(function Checkbox(_ref, ref) {
  var checked = _ref.checked,
      children = _ref.children,
      _ref$classes = _ref.classes,
      classes = _ref$classes === void 0 ? defaultPropObject : _ref$classes,
      disabled = _ref.disabled,
      id = _ref.id,
      indeterminateProp = _ref.indeterminate,
      invalid = _ref.invalid,
      name = _ref.name,
      onChange = _ref.onChange,
      readOnly = _ref.readOnly,
      required = _ref.required,
      tabIndex = _ref.tabIndex,
      _ref$textProps = _ref.textProps,
      textProps = _ref$textProps === void 0 ? defaultPropObject : _ref$textProps,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'b2c' : _ref$theme,
      value = _ref.value,
      rest = _objectWithoutProperties(_ref, _excluded);

  var _useState = useState(indeterminateProp),
      _useState2 = _slicedToArray(_useState, 2),
      indeterminate = _useState2[0],
      setIndeterminate = _useState2[1];

  useEffect(function () {
    setIndeterminate(indeterminateProp);
  }, [indeterminateProp]);
  var handleChange = useCallback(function (e) {
    if (onChange) {
      onChange(e);
    }

    setIndeterminate(false);
  }, [onChange]);
  return /*#__PURE__*/React.createElement("label", _extends({}, rest, {
    className: cx('root', classes.root)
  }), /*#__PURE__*/React.createElement(CheckboxBase, {
    checked: checked,
    classes: _objectSpread(_objectSpread({}, classes), {}, {
      root: cx('checkbox', classes.base)
    }),
    disabled: disabled,
    id: id,
    indeterminate: indeterminate,
    invalid: invalid,
    name: name,
    onChange: handleChange,
    readOnly: readOnly,
    ref: ref,
    required: required,
    tabIndex: tabIndex,
    theme: theme,
    value: value
  }), children && /*#__PURE__*/React.createElement("span", {
    className: cx('text', classes.text)
  }, /*#__PURE__*/React.createElement(TextBase, _extends({}, textProps, {
    as: "span",
    color: disabled ? 'N100' : 'N900',
    size: "m"
  }), children)));
});
export default Checkbox;